import React, { useMemo } from 'react'
import { Button, withStyles } from '@material-ui/core'
import style from './style'

const SequencesControlButtons = ({
  classes,
  seqStatus,
  onClickCreateSequence,
  userRole,
  onDuplicateSequence,
  onDuplicateSequenceForCities,
  onBulkArchive,
  selectedRows,
  pipelineStage,
}) => {
  const createDisabled = useMemo(
    () => ['all', 'videoOnboarding', 'quiz'].includes(pipelineStage),
    [pipelineStage],
  )
  return (
    <div className={classes.wrapper}>
      <div className={classes.topButtonWrapper}>
        <div>
          <h2 style={{ fontWeight: 'bold', margin: 0 }}>
            {seqStatus == 'ACTIVE' ? 'Active' : 'Archived'} Sequences
          </h2>
        </div>
        <div className={classes.buttonsWrapper}>
          <div className={classes.createSequenceButtonWrapper}>
            <div>
              <Button
                className={`${classes.button} ${
                  createDisabled ? '' : classes.createSequenceButton
                }`}
                variant="outlined"
                onClick={onClickCreateSequence}
                disabled={createDisabled}
              >
                + Create sequence
              </Button>
            </div>
            <div>
              {createDisabled && (
                <span className={classes.warn}>
                  Please select another stage option to create a sequence
                </span>
              )}
            </div>
          </div>
          {userRole === 'ADMIN' && (
            <Button
              className={classes.button}
              variant="outlined"
              onClick={onDuplicateSequence}
            >
              Copy all sequences to all cities
            </Button>
          )}
          {userRole === 'ADMIN' && (
            <Button
              className={classes.button}
              variant="outlined"
              disabled={Object.keys(selectedRows).length === 0}
              onClick={onDuplicateSequenceForCities(Object.keys(selectedRows))}
            >
              Copy selected sequences to other cities
            </Button>
          )}
          {userRole === 'ADMIN' && (
            <Button
              className={classes.button}
              variant="outlined"
              disabled={Object.keys(selectedRows).length === 0}
              onClick={onBulkArchive(Object.keys(selectedRows))}
            >
              Bulk Archive
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default withStyles(style)(SequencesControlButtons)
